import { OPEN_THIRD_PARTY_WIDGET, HIDE_THIRD_PARTY_WIDGET } from 'calling-global-api/constants/EventListeners';
import CallingProvider from 'calling-internal-common/call-provider/records/CallingProvider';
import { useEffect } from 'react';
import { getHsCalling } from '../utils/getHsCalling';
import { useThirdPartyGates } from './useThirdPartyGates';
import { useSelectedProviderContext } from 'calling-remote-common/context/SelectedProviderContext';
export const useOpenThirdPartyWidgetEvent = (selectedCallProviderData, openWidget, hideWidget) => {
  const {
    isUngatedForExtensionsInboundCalling,
    isUngatedForClickToCallMigration
  } = useThirdPartyGates();
  const {
    isThirdPartyProviderSelected,
    isUserPreferencesProviderUnset
  } = useSelectedProviderContext();
  useEffect(() => {
    if (isUngatedForClickToCallMigration || !openWidget || !isUngatedForExtensionsInboundCalling || !isThirdPartyProviderSelected || isUserPreferencesProviderUnset || !selectedCallProviderData.supportsInboundCalling) {
      return;
    }
    const hsCalling = getHsCalling();
    const handleOpenWidget = payload => {
      if (payload.showProviderMenu) {
        return;
      }
      // Add calling provider to the OPEN_THIRD_PARTY_WIDGET payload
      // as this is the latest data from the SelectedProviderContext
      const callingProvider = new CallingProvider(selectedCallProviderData);
      openWidget(Object.assign({}, payload, {
        callingProvider
      }));
    };
    hsCalling.addEventListener({
      event: OPEN_THIRD_PARTY_WIDGET,
      callback: handleOpenWidget
    });
    return () => {
      hsCalling.removeEventListener({
        event: OPEN_THIRD_PARTY_WIDGET,
        callback: handleOpenWidget
      });
    };
  }, [openWidget, selectedCallProviderData, isUngatedForExtensionsInboundCalling, isThirdPartyProviderSelected, isUserPreferencesProviderUnset, isUngatedForClickToCallMigration]);
  useEffect(() => {
    if (isUngatedForClickToCallMigration || !hideWidget || !isUngatedForExtensionsInboundCalling || !isThirdPartyProviderSelected || !selectedCallProviderData.supportsInboundCalling) {
      return;
    }
    const hsCalling = getHsCalling();
    hsCalling.addEventListener({
      event: HIDE_THIRD_PARTY_WIDGET,
      callback: hideWidget
    });
    return () => {
      hsCalling.removeEventListener({
        event: HIDE_THIRD_PARTY_WIDGET,
        callback: hideWidget
      });
    };
  }, [hideWidget, isUngatedForExtensionsInboundCalling, isThirdPartyProviderSelected, selectedCallProviderData.supportsInboundCalling, isUngatedForClickToCallMigration]);
};